import { render } from "./PackageDisabler.vue?vue&type=template&id=af52fbae"
import script from "./PackageDisabler.vue?vue&type=script&lang=js"
export * from "./PackageDisabler.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__